import React, { useContext } from "react";
import { MovieContext } from "../../app-context/MovieContext";

const MovieCard = ({ movie }) => {
  const { addToWatchlist } = useContext(MovieContext);

  return (
    <div className="p-4 border border-gray-300 rounded">
      <img
        src={movie.Poster}
        alt={movie.Title}
        className="w-full h-64 object-cover"
      />
      <h2 className="text-xl mt-2">{movie.Title}</h2>
      <p>{movie.Year}</p>
      <button
        onClick={() => addToWatchlist(movie)}
        className="mt-2 p-2 bg-red-500 text-white rounded"
      >
        Add to Watchlist
      </button>
    </div>
  );
};

export default MovieCard;
